import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

// TikTok icon (lucide-react n'inclut pas TikTok en février 2026)
export function TikTokIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M19.321 5.562a5.124 5.124 0 0 1-3.415-1.29 5.113 5.113 0 0 1-1.638-3.272h-3.253V15.02a3.088 3.088 0 0 1-3.088 3.089 3.088 3.088 0 0 1-3.087-3.089 3.088 3.088 0 0 1 3.087-3.088c.34 0 .666.055.972.156v-3.317a6.383 6.383 0 0 0-.972-.074A6.406 6.406 0 0 0 1.53 15.104a6.406 6.406 0 0 0 6.397 6.406 6.406 6.406 0 0 0 6.406-6.406V9.116a8.353 8.353 0 0 0 4.988 1.63V7.494a5.108 5.108 0 0 1 0-1.932z" />
    </svg>
  );
}

export const SOCIAL_PLATFORMS = [
  { key: "facebook", label: "Facebook", icon: Facebook, placeholder: "https://facebook.com/votre-page", color: "text-[#1877F2]" },
  { key: "instagram", label: "Instagram", icon: Instagram, placeholder: "https://instagram.com/votre-compte", color: "text-[#E1306C]" },
  { key: "tiktok", label: "TikTok", icon: TikTokIcon, placeholder: "https://tiktok.com/@votre-compte", color: "text-ink" },
  { key: "youtube", label: "YouTube", icon: Youtube, placeholder: "https://youtube.com/@votre-chaine", color: "text-[#FF0000]" },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, placeholder: "https://linkedin.com/in/votre-profil", color: "text-[#0A66C2]" },
];

/** Affiche les icônes cliquables des réseaux sociaux renseignés par le pro. */
export function SocialLinks({ socials, size = "sm" }) {
  if (!socials || typeof socials !== "object") return null;
  const filled = SOCIAL_PLATFORMS.filter((p) => (socials[p.key] || "").trim());
  if (filled.length === 0) return null;
  const btnSize = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const iconSize = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="social-links">
      {filled.map((p) => {
        const Ico = p.icon;
        return (
          <a
            key={p.key}
            href={socials[p.key]}
            target="_blank"
            rel="noreferrer"
            className={`${btnSize} rounded-full bg-white border border-border flex items-center justify-center tap-scale ${p.color} hover:border-brand transition-colors`}
            title={p.label}
            aria-label={p.label}
            data-testid={`social-link-${p.key}`}
          >
            <Ico className={iconSize} />
          </a>
        );
      })}
    </div>
  );
}
